import axios from "app/utils/http/http";
import { getStore } from "app/configureStore";
import env from "app/utils/env";
import {
	FETCH_HOTEL_ONLY_FILTERS,
	SEND_ESTIMATE_HOTELONLY,
} from "app/pages/HotelOnly/HotelOnlyActionTypes";
import {
	BOOK,
	BOOK_EXTERNAL_PAYMENT,
	CLEAR_PROMOTION_VALUE,
	PAYMENT_CALLBACK,
	SEND_PROMOTION_CODE,
} from "app/actionTypes";
import { getCredentials } from "app/utils/auth";
import { getOperatorAuthToken } from "app/pages/Auth/authSelectors";
import qs from "qs";

export const FETCH_HOTELS = "FETCH_HOTELS";
export const FETCH_HOTELS_REQUEST = "FETCH_HOTELS_REQUEST";
export const FETCH_HOTELS_SUCCESS = "FETCH_HOTELS_SUCCESS";
export const RESET_HOTEL_ONLY_BOOKING_FLOW_ID = "RESET_HOTEL_ONLY_BOOKING_FLOW_ID";
export const SAVE_HOTEL_ONLY_LISTING_URL = "SAVE_HOTEL_ONLY_LISTING_URL";

export const saveHotelOnlyListingUrl = listingUrl => ({
	type: SAVE_HOTEL_ONLY_LISTING_URL,
	listingUrl,
});

let fetchHotelsController = null;

export const fetchHotels = quotationPayload => {
	const endpoint = env("HOTEL_ONLY_API_URL");

	if (fetchHotelsController) {
		fetchHotelsController.abort();
	}

	fetchHotelsController = new AbortController();

	return {
		type: FETCH_HOTELS,
		promise: axios.post(
			`${endpoint}/quote`,
			{ ...quotationPayload },
			{ signal: fetchHotelsController.signal }
		),
	};
};

// Le SSR passe shop et productsVisibility de la requête : le store renvoyé par getStore() est
// un singleton de module que chaque requête serveur remplace.
export const fetchHotelOnlySearchFormAvailability = (params = {}) => {
	const state = getStore().getState();
	const shop = params.shop ?? state.shop;
	const productsVisibility = params.productsVisibility ?? state.productsVisibility;
	const endpoint = env("CONTENT_API_URL") || env("BASE_URL");

	return {
		type: FETCH_HOTEL_ONLY_FILTERS,
		promise: axios.get(
			`${endpoint}/${productsVisibility}/${shop}/hypnos/hotel_destinations.json`
		),
	};
};

export const hotelOnlyBookExternalPayment = ({ bookingFlowId }) => {
	const url = `${env("HOTEL_ONLY_API_URL")}/bookExternalPayment`;

	return {
		type: BOOK_EXTERNAL_PAYMENT,
		promise: axios.post(
			url,
			{ bookingFlowId },
			{
				headers: {
					"Content-type": "application/json",
				},
			}
		),
	};
};

export const hotelOnlyPaymentCallback = ({ format, bookingFlowId, adyenStateDataDetails = {} }) => {
	const payload = {
		...(Object.keys(adyenStateDataDetails).length > 0 && {
			adyenAdditionalDetails: JSON.stringify(adyenStateDataDetails),
		}),
	};

	const data = Object.keys(payload).length > 0 ? qs.stringify(payload) : "";

	return {
		type: PAYMENT_CALLBACK,
		promise: axios.post(`${env("HOTEL_ONLY_API_URL")}/paymentCallback`, data, {
			params: { format, bookingFlowId },
			headers: {
				"Content-type": "application/x-www-form-urlencoded",
			},
		}),
	};
};

export const hotelOnlyBook = paymentPayload => {
	const url = `${env("HOTEL_ONLY_API_URL")}/book`;
	const { token } = getCredentials();
	const headers = {
		Authorization: token,
		"Content-type": "application/json",
	};
	return {
		type: BOOK,
		promise: axios.post(url, paymentPayload, { headers }),
	};
};

const parsePayloadHotelOnlyPromotionCode = ({ userBiid, code, promoCode }) => ({
	...(userBiid && { userBiid }),
	...(code && { bookingFlowId: code }),
	...(promoCode ? { promoCode } : { promoCode: "" }),
});

export const sendHotelOnlyPromotionCode = payload => {
	return {
		type: SEND_PROMOTION_CODE,
		promise: axios.post(
			`${env("HOTEL_ONLY_API_URL")}/promoCode`,
			parsePayloadHotelOnlyPromotionCode(payload),
			{
				headers: {
					"Content-type": "application/json",
				},
			}
		),
	};
};

export const clearHotelOnlyPromotionValue = payload => {
	return {
		type: CLEAR_PROMOTION_VALUE,
		promise: axios.post(
			`${env("HOTEL_ONLY_API_URL")}/promoCode`,
			parsePayloadHotelOnlyPromotionCode(payload),
			{
				headers: {
					"Content-type": "application/json",
				},
			}
		),
	};
};

export const resetHotelOnlyBookingFlowId = () => {
	return {
		type: RESET_HOTEL_ONLY_BOOKING_FLOW_ID,
	};
};

// l'api du sales tools que tu appelles est protégée.
// Pour y avoir accès il faut utiliser le token cognito que l'agent reçoit quand il se connecte au sales tools.
// Il faut recupérer le paramètre 'agentToken' dans la redirect url .
// Il faudra mettre un header 'Authorization = agentToken' pour appeler l'api du sales tools quand tu fais sendEstimate.
export const sendEstimateHotelOnly = payload => {
	const state = getStore().getState();

	const token = getOperatorAuthToken(state);

	return {
		type: SEND_ESTIMATE_HOTELONLY,
		promise: axios.post(`${env("SALES_API_URL")}/hotelonly/estimate`, payload, {
			headers: {
				Authorization: token,
				"Content-type": "text/plain",
			},
		}),
	};
};
